<template>
    <vs-popup id="add-card-popup" title="Add Card" :active.sync="addCardPopup.isOpen">
        <div class="flex-center payment-type-radio-group">
            <vs-radio v-model="card_type" vs-name="card_type" vs-value="visa" class="m-4" :class="{'is-active' : card_type == 'visa'}">
                <img src="../../assets/images/primary-visa-card.svg" v-if="card_type == 'visa'" />
                <img src="../../assets/images/visa-card.svg" v-else />
            </vs-radio>
            <vs-radio v-model="card_type" vs-name="card_type" vs-value="master" class="m-4" :class="{'is-active' : card_type == 'master'}">
                <img src="../../assets/images/primary-master-card.svg" v-if="card_type == 'master'" />
                <img src="../../assets/images/master-card.svg" v-else />
            </vs-radio>
            <vs-radio v-model="card_type" vs-name="card_type" vs-value="discover" class="m-4" :class="{'is-active' : card_type == 'discover'}">
                <img src="../../assets/images/primary-discover-card.svg" v-if="card_type == 'discover'" />
                <img src="../../assets/images/discover-card.svg" v-else />
            </vs-radio>
            <vs-radio v-model="card_type" vs-name="card_type" vs-value="amex" class="m-4" :class="{'is-active' : card_type == 'amex'}">
                <img src="../../assets/images/primary-amex-card.svg" v-if="card_type == 'amex'" />
                <img src="../../assets/images/amex-card.svg" v-else />
            </vs-radio>
        </div>

        <div class="text-sm py-5">
            <div class="mb-4">
                <label>Cardholder’s Name</label>
                <vs-input class="w-full mt-1"></vs-input>
            </div>
            <div class="mb-4">
                <label>Card Number</label>
                <vs-input maxlength="19" v-model="card_number" class="w-full mt-1" v-on:keypress="isNumber($event, 'card-number')"></vs-input>
            </div>
            <div class="flex align-center justify-between mb-2">
                <div class="w-3/5">
                    <label>Expiration Date</label>
                    <!-- <vs-input class="w-full mt-1"></vs-input> -->
                    <date-picker class="text-sm mt-1 expired-date-picker" v-model="expired_date" format="MM/YY" type="month" :editable="false" :clearable="false" placeholder="MM/YY"></date-picker>
                </div>
                <div class="w-2/5 pl-12">
                    <label>CVV</label>
                    <vs-input maxlength="3" v-model="cvv" class="w-full mt-1" v-on:keypress="isNumber($event)"></vs-input>
                </div>
            </div>
        </div>

        <vs-checkbox class="text-sm mx-0 save-card-checkbox">Save Card</vs-checkbox>

        <div class="flex-center mt-12">
            <vs-button class="text-sm" style="width: 150px;">Submit</vs-button>
        </div>
    </vs-popup>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    name: "add-card-popup",
    components: { DatePicker },
    props: {
        addCardPopup: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            card_type: 'visa',
            card_holder_name: '',
            card_number: '',
            cvv: '',
            expired_date: '',
        }
    },
    methods: {
        isNumber: function(evt, type = null) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                if(type == 'card-number' && (this.card_number.toString().length + 1) % 5 == 0 && this.card_number.toString().length != 19) {
                    this.card_number += ' ';
                }
                return true;
            }
        },
    }
}
</script>